import React from 'react';
import type { PluginProps } from 'ricos-types';

import PollViewer from '../viewer/poll-viewer';

export const Poll: React.FC<PluginProps> = ({
  settings,
  componentData,
  node,
  updateAttributes,
  selected,
}) => {
  const block = { getKey: () => node.attrs.id };
  const helpers = { handleFileUpload: settings.handleFileUpload };

  return (
    <div>
      <PollViewer
        componentData={componentData}
        settings={settings}
        updateAttributes={updateAttributes}
        block={block}
        selected={selected}
        helpers={helpers}
      />
    </div>
  );
};
